export default function NetToolkitSupport() {
  return (
    <main className="min-h-screen bg-[#FBFAF6] text-[#26313B]">
      <section className="mx-auto max-w-3xl px-6 py-12">
        <header className="mb-8 text-center">
          <h1 className="text-4xl font-extrabold tracking-tight text-[#A8720E]">
            Support - Network Toolkit
          </h1>
          <p className="mt-2 text-sm text-[#5B6B7C]">
            Help, troubleshooting, and contact details for Network Toolkit.
          </p>
          <p className="mt-1 text-xs text-[#8A93A2]">
            Published by <span className="font-semibold">Cosmovex</span>
          </p>
        </header>

        <div className="space-y-8 leading-relaxed text-[#3D4B59]">
          <h2 className="text-2xl font-bold text-[#A8720E]">
            Frequently Asked Questions
          </h2>

          <div className="space-y-6">
            <div>
              <h3 className="text-lg font-semibold text-[#26313B]">
                How do I ping a host?
              </h3>
              <p className="mt-1">
                Tap Ping from the home screen. Enter a hostname or IP address
                and tap Start. The app will send ICMP packets and display
                round-trip times, packet loss, and statistics.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-[#26313B]">
                How do I run a traceroute?
              </h3>
              <p className="mt-1">
                Tap Traceroute, enter the destination hostname or IP, and tap
                Start. Each hop along the route is displayed with its IP address
                and latency.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-[#26313B]">
                How do I scan ports?
              </h3>
              <p className="mt-1">
                Tap Port Scanner, enter the target IP address and the port range
                you want to scan, then tap Scan. Open ports are highlighted in
                the results.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-[#26313B]">
                How do I look up DNS records?
              </h3>
              <p className="mt-1">
                Tap DNS Lookup, enter a domain name, and select the record type
                (A, AAAA, MX, TXT, CNAME, etc.). The app queries the DNS system
                and returns the matching records.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-[#26313B]">
                How do I check my network speed?
              </h3>
              <p className="mt-1">
                Tap Speed Test and tap Start. The app measures your download and
                upload speeds and displays the results along with your ping
                latency.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-[#26313B]">
                Why does the app show ads?
              </h3>
              <p className="mt-1">
                Ads help support continued development. You can remove all ads
                with a one-time in-app purchase from Settings.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-[#26313B]">
                The app is crashing. What do I do?
              </h3>
              <p className="mt-1">
                Try closing and reopening the app. Make sure you have the latest
                version from the App Store or Google Play. Email us with your
                device model, OS version, app version, and steps to reproduce.
              </p>
            </div>
          </div>

          <h2 className="text-2xl font-bold text-[#A8720E]">
            Contact Support
          </h2>
          <p>
            For help, bug reports, or privacy-related questions, email{" "}
            <a
              href="mailto:trionapps@gmail.com"
              className="text-[#0F6BBF] underline"
            >
              trionapps@gmail.com
            </a>
            . We usually respond within 24-48 hours.
          </p>

          <h2 className="text-2xl font-bold text-[#A8720E]">Report a Bug</h2>
          <p>
            If something is not working as expected, include these details in
            your email:
          </p>
          <ul className="list-disc space-y-1 pl-6">
            <li>Your device model and OS version</li>
            <li>Your app version (found in Settings &gt; About)</li>
            <li>What you were trying to do</li>
            <li>The error or unexpected result</li>
            <li>Steps to reproduce the issue, if known</li>
          </ul>

          <h2 className="text-2xl font-bold text-[#A8720E]">Important Links</h2>
          <ul className="list-disc space-y-1 pl-6">
            <li>
              Privacy Policy:{" "}
              <a
                href="/apps/nettoolkit/privacy-policy"
                className="text-[#0F6BBF] underline"
              >
                cosmovexapps.com/apps/nettoolkit/privacy-policy
              </a>
            </li>
            <li>
              Support:{" "}
              <a
                href="/apps/nettoolkit/support"
                className="text-[#0F6BBF] underline"
              >
                cosmovexapps.com/apps/nettoolkit/support
              </a>
            </li>
          </ul>

          <h2 className="text-2xl font-bold text-[#A8720E]">App Information</h2>
          <ul className="list-disc space-y-1 pl-6">
            <li>
              <strong>App Name:</strong> Network Toolkit
            </li>
            <li>
              <strong>Package:</strong> com.cosmovex.nettoolkit
            </li>
            <li>
              <strong>Developer:</strong> Cosmovex
            </li>
            <li>
              <strong>Contact:</strong>{" "}
              <a
                href="mailto:trionapps@gmail.com"
                className="text-[#0F6BBF] underline"
              >
                trionapps@gmail.com
              </a>
            </li>
          </ul>
        </div>

        <footer className="mt-12 border-t border-[#E1DCCE] pt-4 text-sm text-[#8A93A2]">
          &copy; 2026 Cosmovex - All rights reserved.
        </footer>
      </section>
    </main>
  );
}
